import { cn } from '@/shared/lib'

/**
 * 24 линейные иконки TuhfaQL — `design/assets/Data/icons.json` дословно.
 * Других иконок и эмодзи в интерфейсе нет (CLAUDE.md, «Цвет»).
 */
const ICON_PATHS = {
  gift: [
    'M5 8h14v13H5z',
    'M3 8h18',
    'M12 8v13',
    'M12 8 8.5 4.5a2.5 2.5 0 0 1 3.5 0',
    'M12 8l3.5-3.5a2.5 2.5 0 0 0-3.5 0',
    'M3 8h18v4H3z',
  ],
  ticket: [
    'M3 8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2a2 2 0 0 0 0-4z',
    'M13 6v12',
  ],
  chevron: ['m9 5 7 7-7 7'],
  back: ['M19 12H5', 'm12 19-7-7 7-7'],
  check: ['m4 13 5 5L20 6'],
  checkCircle: ['M21 12a9 9 0 1 1-9-9 9 9 0 0 1 9 9z', 'm8 12.5 2.5 2.5L16 9.5'],
  copy: [
    'M9 11a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2z',
    'M15 5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2',
  ],
  moon: ['M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z'],
  sun: [
    'M16 12a4 4 0 1 1-4-4 4 4 0 0 1 4 4z',
    'M12 3v2',
    'M12 19v2',
    'M3 12h2',
    'M19 12h2',
    'm6 6 1.5 1.5',
    'M16.5 16.5 18 18',
    'M18 6l-1.5 1.5',
    'M7.5 16.5 6 18',
  ],
  globe: ['M21 12a9 9 0 1 1-9-9 9 9 0 0 1 9 9z', 'M3 12h18', 'M12 3a14 14 0 0 1 0 18a14 14 0 0 1 0-18'],
  pin: ['M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11z', 'M14.5 10a2.5 2.5 0 1 1-2.5-2.5A2.5 2.5 0 0 1 14.5 10z'],
  wifiOff: [
    'M3 8.5a15 15 0 0 1 6-3.2',
    'M15.5 5.8A15 15 0 0 1 21 8.5',
    'M7 12.5a10 10 0 0 1 3-1.7',
    'M17.5 13.6a10 10 0 0 0-2-1.4',
    'M13 18a1 1 0 1 1-1-1 1 1 0 0 1 1 1z',
    'm3 3 18 18',
  ],
  clock: ['M21 12a9 9 0 1 1-9-9 9 9 0 0 1 9 9z', 'M12 7v5.5l3.5 2'],
  card: ['M2.5 7.5A2.5 2.5 0 0 1 5 5h14a2.5 2.5 0 0 1 2.5 2.5v9A2.5 2.5 0 0 1 19 19H5a2.5 2.5 0 0 1-2.5-2.5z', 'M2.5 10h19'],
  search: ['M17.5 11a6.5 6.5 0 1 1-6.5-6.5 6.5 6.5 0 0 1 6.5 6.5z', 'm16 16 4.5 4.5'],
  x: ['M6 6l12 12', 'M18 6 6 18'],
  sparkles: [
    'M11 3l1.8 4.7L17.5 9.5l-4.7 1.8L11 16l-1.8-4.7L4.5 9.5l4.7-1.8z',
    'M18 15l.9 2.1 2.1.9-2.1.9L18 21l-.9-2.1-2.1-.9 2.1-.9z',
  ],
  package: ['M21 8.5v7L12 21l-9-5.5v-7L12 3z', 'M3 8.5 12 13l9-4.5', 'M12 13v8'],
  history: ['M3.5 12a8.5 8.5 0 1 0 3-6.5', 'M3 4v4h4', 'M12 8v4.5l3 1.8'],
  alert: ['M10.3 4.3 2.8 17a2 2 0 0 0 1.7 3h15a2 2 0 0 0 1.7-3L13.7 4.3a2 2 0 0 0-3.4 0z', 'M12 9v4', 'M12 16.5h.01'],
  qr: ['M4 4h5v5H4z', 'M15 4h5v5h-5z', 'M4 15h5v5H4z', 'M14 14h3v3h-3z', 'M20 14v3', 'M14 20h7'],
  send: ['M21 3 10.5 13.5', 'M21 3l-6.5 18-4-7.5L3 9.5z'],
  navigate: ['M3.5 11 20.5 3.5 13 20.5l-2-7.5z'],
  loader: [
    'M12 3v3.5',
    'M12 17.5V21',
    'M3 12h3.5',
    'M17.5 12H21',
    'm6 6 2.5 2.5',
    'm15.5 15.5 2.5 2.5',
    'M18 6l-2.5 2.5',
    'M8.5 15.5 6 18',
  ],
} as const satisfies Record<string, readonly string[]>

export type IconName = keyof typeof ICON_PATHS

type IconProps = {
  name: IconName
  /** Размер в px. Значения по местам — таблица в `design/components/Icon/README.md`. */
  size?: number
  /** Толщина линии, 1–2.6; по умолчанию 1.8. */
  stroke?: number
  /** Цвет — классом `text-*`: иконка рисуется `currentColor`. */
  className?: string
  /** Подпись для скринридера; без неё иконка декоративная. */
  label?: string
}

/**
 * Иконка набора: сетка 24×24, без заливки, скруглённые концы и углы,
 * `stroke="currentColor"`.
 */
export const Icon = ({ name, size = 20, stroke = 1.8, className, label }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    role={label ? 'img' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
    focusable="false"
    className={cn('block flex-none', className)}
  >
    {ICON_PATHS[name].map((d) => (
      <path key={d} d={d} />
    ))}
  </svg>
)
